import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NatOverviewComponent } from '@natiwi/overview/overview.component';

@NgModule({
  declarations: [NatOverviewComponent],
  imports: [
    CommonModule
  ]
})
export class NatOverviewModule { }
